/* Mobile instafeed: accept a milder sideways gesture than the browser
   does, then keep the row locked to the finger and ease it to the
   nearest photo when the finger lifts. */
(function () {
  var SELECTOR = '[id$="17888949902172f526"] .section-content-wrapper';
  var bound = new WeakSet();

  function bind(scroller) {
    if (bound.has(scroller)) return;
    bound.add(scroller);

    var startX = 0;
    var startY = 0;
    var origin = 0;
    var axis = null;
    var lastX = 0;
    var lastTime = 0;
    var velocity = 0;
    var frame = 0;

    function stopSettle() {
      if (!frame) return;
      cancelAnimationFrame(frame);
      frame = 0;
    }

    function settle() {
      var item = scroller.querySelector('.instafeed-new-layout-item');
      if (!item) return;
      var row = scroller.querySelector('.instafeed-new-layout-wrapper') || scroller;
      var styles = getComputedStyle(row);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var step = item.getBoundingClientRect().width + gap;
      if (!step) return;

      var max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      var index = scroller.scrollLeft / step;
      if (velocity < -0.45) index = Math.ceil(index);
      else if (velocity > 0.45) index = Math.floor(index);
      else index = Math.round(index);

      var target = Math.max(0, Math.min(max, index * step));
      var from = scroller.scrollLeft;
      var distance = target - from;
      if (Math.abs(distance) < 1) {
        scroller.scrollLeft = target;
        return;
      }

      var duration = 180;
      var started = 0;

      function tick(now) {
        if (!started) started = now;
        var t = Math.min(1, (now - started) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        scroller.scrollLeft = from + distance * eased;
        if (t < 1) frame = requestAnimationFrame(tick);
        else frame = 0;
      }

      frame = requestAnimationFrame(tick);
    }

    scroller.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length !== 1) return;
        stopSettle();
        startX = lastX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        origin = scroller.scrollLeft;
        lastTime = event.timeStamp;
        velocity = 0;
        axis = null;
      },
      { passive: true }
    );

    scroller.addEventListener(
      'touchmove',
      function (event) {
        if (event.touches.length !== 1 || axis === 'y') return;
        var x = event.touches[0].clientX;
        var y = event.touches[0].clientY;
        var dx = x - startX;
        var dy = y - startY;

        if (!axis) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          axis = Math.abs(dx) > Math.abs(dy) * 0.45 ? 'x' : 'y';
        }

        if (axis !== 'x') return;
        if (event.cancelable) event.preventDefault();

        var dt = event.timeStamp - lastTime;
        if (dt > 0) velocity = (x - lastX) / dt;
        lastX = x;
        lastTime = event.timeStamp;
        scroller.scrollLeft = origin - dx;
      },
      { passive: false }
    );

    function end() {
      if (axis !== 'x') return;
      settle();
    }

    scroller.addEventListener('touchend', end, { passive: true });
    scroller.addEventListener('touchcancel', end, { passive: true });
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var root = document.querySelector('[id$="17888949902172f526"]');
  if (root) {
    new MutationObserver(scan).observe(root, { childList: true, subtree: true });
  }
})();
